/**
 * Dropdowns
 *
 * Handles desktop and mobile dropdown functionality
 *
 * @author Daine Mawer, 10up
 */
( function () {
	'use strict';

	const pageNavigation = document.getElementById( 'js-site-secondary-navigation' );
	const dropdowns = document.querySelectorAll(
		'.site-header__has-dropdown > a, .site-header__has-dropdown > button'
	);

	// If we have secondary pagniation in the header, add a class to the <body>
	pageNavigation && !document.body.classList.contains( 'page-template-page-nesn360-mlp' ) && document.body.classList.add( 'page-navigation-supported' );

	/**
	 * Handles the click event on anchor items
	 * generated by wp_nav_menu in the header
	 *
	 * @param object e
	 * @return void
	 */
	const handleClick = e => {
		const { target } = e;
		const { parentElement } = target;
		const { children } = target;

		/* eslint-disable prefer-destructuring */
		const buttonText = children[ 0 ];
		/* eslint-enable prefer-destructuring */
		const isTextButton = target.classList.contains( 'site-header__button-text' );

		e.preventDefault();

		parentElement.classList.toggle( 'dropdown-is-active' );

		/**
		 * Add another class to the body to prevent scrolling on mobile
		 * @note Daine to look at this again before launch.
		 */
		if ( parentElement.classList.contains( 'dropdown-is-active' ) ) {
			document.body.classList.add( 'dropdown-active' );
			// Toggle the aria-expanded attribute
			target.setAttribute( 'aria-expanded', true );
			if ( isTextButton ) {
				buttonText.innerHTML = 'Close';
			}
		} else {
			document.body.classList.remove( 'dropdown-active' );
			target.setAttribute( 'aria-expanded', false );
			if ( isTextButton ) {
				buttonText.innerHTML = 'Scores';
			}
		}
	};

	/**
	 * Handles closing the dropdowns when the Escape Key is pressed.
	 *
	 * @param object e
	 * @return void
	 */
	const handleEscapeKey = e => {
		const { keyCode } = e;
		if ( 27 === keyCode ) {
			dropdowns && dropdowns.forEach( dropdown => {
				const isDropDownActive = dropdown.classList.contains( 'dropdown-is-active' );
				if ( isDropDownActive ) {
					dropdown.classList.remove( 'dropdown-is-active' );
				}
			} );

			document.body.classList.remove( 'dropdown-active' );
		}
	};

	/**
	 * Handles click events when clicking outside of dropdowns
	 * This helps with user experience and closes dropdowns when
	 * interacting with other UI
	 *
	 * @param object e
	 * @return void
	 */
	const handleClickOutside = ( e ) => {
		const { target } = e;
		dropdowns && dropdowns.forEach( dropdown => {
			// Toggle the aria-expanded attribute
			const isDropDownActive = dropdown.parentElement.classList.contains( 'dropdown-is-active' );
			if ( !dropdown.parentElement.contains( target ) && isDropDownActive ) {
				dropdown.setAttribute( 'aria-expanded', false );
				dropdown.parentElement.classList.remove( 'dropdown-is-active' );
				document.body.classList.remove( 'dropdown-active' );
			}
		} );
	};

	// Loop over elements and bind click event
	dropdowns &&
		dropdowns.forEach( ( dropdown ) => {
			dropdown.addEventListener( 'click', handleClick, false );
		} );

	// Bind events to document
	document.addEventListener( 'click', handleClickOutside, false );
	document.addEventListener( 'keydown', handleEscapeKey, false );

} )();
